module.exports = __webpack_public_path__ + "static/media/machine.3011cb01.png";